module.exports = __webpack_public_path__ + "static/media/g9.c803650a.jpg";